import { EmojiEvents } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface RankedCallsEmptyOverlayProps {
  onReopenWizard: () => void;
}

const RankedCallsEmptyOverlay = ({ onReopenWizard }: RankedCallsEmptyOverlayProps): React.ReactElement => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", p: 4 }}>
    <Typography variant="h6" gutterBottom>No matching calls found</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: "center", maxWidth: 400 }}>
      No calls matched your search criteria. Try adjusting your filters:
    </Typography>
    <Box component="ul" sx={{ textAlign: "left", color: "text.secondary" }}>
      <li><Typography variant="body2">Broaden the timeframe (e.g., Last 30 days or All time)</Typography></li>
      <li><Typography variant="body2">Remove the agent filter to include all agents</Typography></li>
      <li><Typography variant="body2">Try a different lens or remove the attribute filter</Typography></li>
    </Box>
    <Button
      variant="outlined"
      size="small"
      startIcon={<EmojiEvents />}
      onClick={onReopenWizard}
      sx={{ mt: 2, textTransform: "none" }}
    >
      Return to Wizard
    </Button>
  </Box>
);

export default RankedCallsEmptyOverlay;
